import { render, staticRenderFns } from "./setPhone.vue?vue&type=template&id=671b4abb"
import script from "./setPhone.vue?vue&type=script&lang=js"
export * from "./setPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports